export default "__VITE_ASSET__w6AkWv10__"